// courses/course_C02.ts

export const course_C02 = `
  <div style="margin-bottom: 25px;">
    <h4 style="color: #0369a1; border-bottom: 2px solid #e2e8f0; padding-bottom: 8px; margin-bottom: 12px;">1. 매니저의 직급 체계와 성장 과정</h4>
    <p style="margin-bottom: 10px; line-height: 1.6;">매니지먼트 업계는 군대나 일반 기업만큼이나 직급 체계가 뚜렷합니다. 현장에서 실무를 배우는 단계부터 경영을 책임지는 단계까지 순차적으로 성장하게 됩니다.</p>
    <ul style="padding-left: 20px; line-height: 1.6;">
      <li style="margin-bottom: 8px;"><strong>현장 매니저 (로드 매니저 / 신입):</strong> 현장의 최전방에서 아티스트와 함께 움직이는 단계입니다.</li>
      <li style="margin-bottom: 8px;"><strong>팀장 / 치프 매니저 (경력 3~5년 내외):</strong> 현장 실무를 총괄하며 전략을 짜기 시작하는 단계입니다.</li>
      <li style="margin-bottom: 8px;"><strong>실장 / 본부장 (경력 7~10년 이상):</strong> 부서의 운영과 아티스트의 방향성을 결정하는 관리자 단계입니다.</li>
      <li><strong>이사 / 대표 (경력 10년 이상 ~ 경영자):</strong> 회사의 경영과 신인 발굴, 콘텐츠 제작을 책임지는 최종 단계입니다.</li>
    </ul>
  </div>

  <div style="margin-bottom: 25px;">
    <h4 style="color: #0369a1; border-bottom: 2px solid #e2e8f0; padding-bottom: 8px; margin-bottom: 12px;">2. 각 단계별 주요 업무와 역할</h4>
    
    <div style="margin-bottom: 18px;">
      <strong style="color: #0284c7; font-size: 1.05rem; display: block; margin-bottom: 8px;">① 현장 매니저 (로드 매니저): "현장의 수호자"</strong>
      <ul style="padding-left: 20px; line-height: 1.6;">
        <li style="margin-bottom: 6px;"><strong>안전한 이동:</strong> 아티스트의 스케줄에 맞춘 정확한 시간 엄수와 안전 운전.</li>
        <li style="margin-bottom: 6px;"><strong>현장 케어:</strong> 촬영장이나 방송국 도착 시 아티스트의 컨디션 체크 및 대기 공간 확보.</li>
        <li><strong>커뮤니케이션의 기초:</strong> 현장 조감독, FD 등 실무 스태프들과 소통하며 스케줄 변동 사항 확인.</li>
      </ul>
    </div>

    <div style="margin-bottom: 18px;">
      <strong style="color: #0284c7; font-size: 1.05rem; display: block; margin-bottom: 8px;">② 팀장 (치프 매니저): "실무의 지휘자"</strong>
      <ul style="padding-left: 20px; line-height: 1.6;">
        <li style="margin-bottom: 6px;"><strong>스케줄 조율:</strong> 방송사 PD, 영화/드라마 제작사와의 구체적인 출연 일정 및 조건 협의.</li>
        <li style="margin-bottom: 6px;"><strong>현장 관리 감독:</strong> 후배 로드 매니저들의 업무를 배정하고 현장에서 발생하는 문제 해결.</li>
        <li><strong>홍보 및 마케팅:</strong> 아티스트의 보도자료 배포 협조 및 현장 비하인드 콘텐츠 기획.</li>
      </ul>
    </div>

    <div style="margin-bottom: 18px;">
      <strong style="color: #0284c7; font-size: 1.05rem; display: block; margin-bottom: 8px;">③ 실장 / 본부장: "전략의 기획자"</strong>
      <ul style="padding-left: 20px; line-height: 1.6;">
        <li style="margin-bottom: 6px;"><strong>캐스팅 및 계약:</strong> 작품 시나리오 검토, 출연료 협상 및 전속 계약 관련 실무 총괄.</li>
        <li style="margin-bottom: 6px;"><strong>브랜딩 전략:</strong> 아티스트가 어떤 이미지로 대중에게 다가갈지 장기적인 로드맵 설정.</li>
        <li><strong>부서 운영:</strong> 매니지먼트 팀의 예산 관리 및 인사 관리.</li>
      </ul>
    </div>

    <div style="margin-bottom: 10px;">
      <strong style="color: #0284c7; font-size: 1.05rem; display: block; margin-bottom: 8px;">④ 이사 / 대표: "최종 의사결정자"</strong>
      <ul style="padding-left: 20px; line-height: 1.6;">
        <li style="margin-bottom: 6px;"><strong>신인 발굴:</strong> 잠재력 있는 원석을 찾아내어 트레이닝시키고 데뷔시키는 투자 결정.</li>
        <li style="margin-bottom: 6px;"><strong>비즈니스 확장:</strong> 광고, 공연, 해외 진출 등 수익 모델 다각화 및 회사 운영.</li>
        <li><strong>네트워크 관리:</strong> 업계 주요 인사들과의 관계 유지 및 대외적인 리스크 최종 책임.</li>
      </ul>
    </div>
  </div>

  <div style="margin-bottom: 25px;">
    <h4 style="color: #0369a1; border-bottom: 2px solid #e2e8f0; padding-bottom: 8px; margin-bottom: 12px;">3. 직급을 불문하고 매니저가 갖춰야 할 3대 소양</h4>
    <p style="margin-bottom: 10px; line-height: 1.6;">어느 단계에 있든 매니저라면 반드시 지켜야 할 핵심 가치입니다.</p>
    <ul style="padding-left: 20px; line-height: 1.6;">
      <li style="margin-bottom: 8px;"><strong>철저한 시간 엄수:</strong> 매니저의 1분은 아티스트와 수백 명 스태프의 1분과 같습니다.</li>
      <li style="margin-bottom: 8px;"><strong>입 무거운 보안 의식:</strong> 아티스트의 사생활과 회사의 내부 정보는 절대 외부로 유출해서는 안 됩니다.</li>
      <li><strong>유연한 태도:</strong> 현장은 늘 변수가 발생합니다. 당황하지 않고 대안을 찾아내는 긍정적인 사고가 필요합니다.</li>
    </ul>
  </div>

  <div style="margin-bottom: 25px;">
    <h4 style="color: #0369a1; border-bottom: 2px solid #e2e8f0; padding-bottom: 8px; margin-bottom: 12px;">4. 매니저 커리어의 비전</h4>
    <p style="margin-bottom: 10px; line-height: 1.6;">매니저는 단순히 '누군가를 챙기는 사람'에 머물지 않습니다. 현장에서 쌓은 인적 네트워크와 콘텐츠를 보는 안목은 향후 엔터테인먼트 대표뿐만 아니라 영화 제작자, 드라마 제작사 대표, 음악 프로듀서 등으로도 성공할 수 있는 가장 강력한 밑거름이 됩니다.</p>
  </div>

  <div style="background-color: #f0f9ff; padding: 20px; border-radius: 12px; border-left: 5px solid #0284c7; margin-top: 30px;">
    <strong style="color: #0369a1; font-size: 1.1rem; display: block; margin-bottom: 10px;">💡 교육생을 위한 한 줄 요약</strong>
    <p style="margin: 0; color: #334155; font-style: italic; line-height: 1.6;">
      "지금 잡고 있는 운전대는 단순한 운전이 아니라, 대한민국 엔터테인먼트의 미래를 이끌어갈 제작자로 가는 첫 번째 과정입니다."
    </p>
  </div>
`;
